import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "configuration" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "table-container"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = ["onUpdate:modelValue", "onClick", "onMousedown", "onMouseover"]
const _hoisted_8 = { class: "configuration" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.start === null)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, " Select the starting point"))
        : (_ctx.end === null)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, " Select the end point"))
          : (_openBlock(), _createElementBlock("h3", _hoisted_4, "Click and hover to block the cell, path can't have a blocked cell")),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        name: "Rows",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.M) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initializeMatrix && _ctx.initializeMatrix(...args)))
      }, null, 544), [
        [_vModelText, _ctx.M]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        name: "Columns",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.N) = $event)),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initializeMatrix && _ctx.initializeMatrix(...args)))
      }, null, 544), [
        [_vModelText, _ctx.N]
      ])
    ]),
    (_ctx.M > 0 && _ctx.N > 0 && _ctx.matrix.length == _ctx.M && _ctx.matrix[0].length == _ctx.N)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", {
            class: "table",
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.canSelectBlockedCellByHover = false))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.M, (row, i) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.N, (col, j) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass({ pathEndpoints: _ctx.matrix[i][j], blocked: _ctx.isBlocked(i, j) }),
                    id: `${i}-${j}`
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "matrix-checkbox",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.matrix[i][j]) = $event),
                      onClick: _withModifiers(($event: any) => (_ctx.markPoint(i, j)), ["prevent"]),
                      onMousedown: ($event: any) => (_ctx.markBlocked(i, j)),
                      onMouseup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.canSelectBlockedCellByHover = false)),
                      onMouseover: ($event: any) => (_ctx.canSelectBlockedCellByHover && _ctx.markBlocked(i, j)),
                      type: "checkbox"
                    }, null, 40, _hoisted_7), [
                      [_vModelCheckbox, _ctx.matrix[i][j]]
                    ])
                  ], 10, _hoisted_6))
                }), 256))
              ]))
            }), 256))
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "findPathButton",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createShortestPath && _ctx.createShortestPath(...args))),
        disabled: !!!_ctx.start || !!!_ctx.end
      }, "Find the shortest path", 8, _hoisted_9),
      _createElementVNode("button", {
        class: "findPathButton",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.initializeMatrix && _ctx.initializeMatrix(...args)))
      }, "Reset")
    ])
  ], 64))
}